<div class="advanced-conditions-container">
  <div class="sub-item-title">Advanced</div>

  <div class="advanced-conditions">
    <div  *ngIf="isQBRUsed(item.quality)">
      <div class="sub-title">Quality paths:</div>
      <div class="sub-item">
        <span [hidden]="item.quality !== 'FAIR'">&nbsp;FAIR or GOOD</span>
        <span [hidden]="item.quality !== 'GOOD'">&nbsp;GOOD</span>
      </div>
    </div>

    <div *ngIf="item.advancedConditions.timeConditions && item.advancedConditions.timeConditions.length > 0">
      <div class="sub-title">Time conditions:</div>
      <div class="sub-item">
               <span *ngFor="let timeCondition of item.advancedConditions.timeConditions; let last = last">
                    <span>&nbsp;{{timeCondition.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
               </span>
      </div>
    </div>

    <div>
      <div class="sub-title">Notify when activated:</div>
      <div class="sub-item">
        <span> {{item.eventOnMatch}} </span>
      </div>
    </div>

    <div>
      <div class="sub-title">Prioritize call:</div>
      <div class="sub-item">
        <span> {{item.isEmergency}} </span>
      </div>
    </div>

    <div>
      <div class="sub-title">Registered users:</div>
      <div class="sub-item">
        <span> {{item.isRegisteredUsers}} </span>
      </div>
    </div>

    <div *ngIf="item.advancedConditions?.sipConditionGroup">
      <div class="sub-title">SIP condition group:</div>
      <div class="sub-item">
        <span> {{item.advancedConditions.sipConditionGroup.name}} </span>
      </div>
    </div>

    <div>
      <div class="sub-title">Request type:</div>
      <div class="sub-item">
        <span [hidden]="item.requestType !== 'CALL'">&nbsp;Call</span>
        <span [hidden]="item.requestType !== 'REGISTER'">&nbsp;Register</span>
      </div>
    </div>

    <div>
      <div class="sub-title">Privacy policy:</div>
      <div class="sub-item">
        <span [hidden]="item.privacy !== 'TRANSPARENT'">&nbsp;Transparent</span>
        <span [hidden]="item.privacy !== 'TRANSPARENT_WITH_PRIVACY_ID'">&nbsp;Transparent with privacy id</span>
        <span [hidden]="item.privacy !== 'ANONYMOUS_CALLER'">&nbsp;Anonymous caller</span>
        <span [hidden]="item.privacy !== 'IDENTIFY_CALLER'">&nbsp;Identify caller</span>
      </div>
    </div>

    <div class="sub-item-title">Call trigger</div>

    <div>
      <div class="sub-title">Initial:</div>
      <div class="sub-item">
        <span> {{item.isTriggerInitialOnly}} </span>
      </div>
    </div>

    <div>
      <div class="sub-title">Refer:</div>
      <div class="sub-item">
        <span> {{item.isTriggerRefer}} </span>
      </div>
    </div>

    <div>
      <div class="sub-title">3xx:</div>
      <div class="sub-item">
        <span> {{item.isTrigger3xx}} </span>
      </div>
    </div>

    <div>
      <div class="sub-title">Broken connection:</div>
      <div class="sub-item">
        <span> {{item.isTriggerBrokenConnection}} </span>
      </div>
    </div>

    <div>
      <div class="sub-title">Fax rerouting:</div>
      <div class="sub-item">
        <span> {{item.isTriggerFaxRerouting}} </span>
      </div>
    </div>

    <div class="sub-item-title">Prevent source loopback</div>

    <div>
      <div class="sub-title">Peer Connection:</div>
      <div class="sub-item">
        <span> {{item.isPreventSourceLoopbackPcon}} </span>
      </div>
    </div>

    <div>
      <div class="sub-title">VoipPeer:</div>
      <div class="sub-item">
        <span> {{item.isPreventSourceLoopbackVoipPeer}} </span>
      </div>
    </div>

    <div>
      <div class="sub-title">Node:</div>
      <div class="sub-item">
        <span> {{item.isPreventSourceLoopbackNode}} </span>
      </div>
    </div>


    <div *ngIf="item.minSecureLogix !== null && item.maxSecureLogix != null">
      <div class="sub-item-title">Security call score:</div>
      <div>
        <div class="sub-title">Minimum:</div>
        <div class="sub-item">
          <span> {{item.minSecureLogix}} </span>
        </div>
      </div>
      <div>
        <div class="sub-title">Maximum:</div>
        <div class="sub-item">
          <span> {{item.maxSecureLogix}} </span>
        </div>
      </div>
    </div>

    <div *ngIf="item.sipHeaders && item.sipHeaders.length > 0">
      <div class="sub-item-title">Sip headers</div>

      <div *ngFor="let key of getSipHeadersKeys()">
        <div class="sub-title">{{key}}:</div>
        <div class="sub-item">
                    <span *ngFor="let header of getSipHeaderKeyValues(key); let last=last;">
                        <span>&nbsp;{{header.value}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                    </span>
        </div>
      </div>
    </div>

    <div *ngIf="item.tags && item.tags.length > 0">
      <div class="sub-item-title">Tags</div>

      <div *ngFor="let key of getTagsKeys()">
        <div class="sub-title">{{key}}:</div>
        <div class="sub-item">
                    <span *ngFor="let header of getTagsKeyValues(key); let last=last;">
                        <span>&nbsp;{{header.value}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                    </span>
        </div>
      </div>
    </div>

  </div>
</div>
